import styled from 'styled-components';

import { Button } from '@terveystalo/design-system-react-components';

export const NewMessageButton = styled(Button)`
	width: 400px;
	max-width: 100%;
`;
